import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import '../Common/styles/Charts.css';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { menus } from './Common/Consts/sidebar';
import Mapping from './Mapping/Mapping';
import Families from './Families/Families';
import People from './People/People';
import Disability from './Disability/Disability';
import StreetSituation from './StreetSituation/StreetSituation';
import { HomeNav } from '../Common/Home/HomeNav';

function DashBoardUnifiedRegistry() {
    const queryClient = new QueryClient();

    return (
        <QueryClientProvider client={queryClient}>
            <ReactQueryDevtools initialIsOpen={false} />
            <div className="dashboards-page">
                <HomeNav menus={menus} />
                <Routes>
                    <Route
                        path="/"
                        element={<Navigate to="mapping" replace />}
                    />

                    <Route path="/mapping/*" element={<Mapping />} />
                    <Route path="/families/*" element={<Families />} />
                    <Route path="/people/*" element={<People />} />
                    <Route path="/disability/*" element={<Disability />} />
                    <Route
                        path="/street-situation/*"
                        element={<StreetSituation />}
                    />
                </Routes>
            </div>
        </QueryClientProvider>
    );
}

export default DashBoardUnifiedRegistry;
